import { Component, OnInit, Output, ViewChild, EventEmitter, Input, ChangeDetectorRef, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'src/assets/config/config/app-config';
import { User } from 'src/app/_models/user';
import { FileInboxVirtualFolderService } from 'src/app/_services/fileInbox-virtualFolder.service';
import { MigrationService } from 'src/app/_services/document-migration.services';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';


@Component({
  selector: 'app-dialog-teams-delete-config',
  templateUrl: './dialog-teams-delete-config.component.html',
  styleUrls: ['./dialog-teams-delete-config.component.scss']
})
export class DialogTeamsDeleteConfigComponent implements OnInit {

  selectedTeamName: any;
  selectedTeamId: any;
  selectedBackupTeamId: number = 0;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  documentCount: number = 0;
  documentCols: String[] = [];
  docResultsList: MatTableDataSource<any>;
  offset: number = 0;
  isDocumentExist: any;
  documents: any;
  teamList = [];

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.docResultsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.docResultsList.paginator = this.paginator;
    }
  }
  
  constructor(
    public dialogRef: MatDialogRef<DialogTeamsDeleteConfigComponent>,
    private migrationService: MigrationService,
    private virtualFolderService: FileInboxVirtualFolderService,
    private config: AppConfig,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) {
    this.selectedTeamName = data['teamName'];
    this.selectedTeamId = data['teamId'];
  }
  
  ngOnInit(): void {
    this.migrationService.getTeamsAll().subscribe(teams => {
      if (teams && teams.length > 0) {
         for (var index in teams) {
            if (teams[index].id !== this.selectedTeamId) {
              this.teamList.push(teams[index]);
            }
         }
      }
    });
    if (this.selectedTeamId && this.selectedTeamId > 0) {
      this.selectTeam(this.selectedTeamName, this.selectedTeamId, 'team');
    }
  }

  close() {
    this.dialogRef.close();
  }

  deleteTeam() {
    let teamIds = [];
    teamIds.push(this.selectedTeamId);
      let request = {
        "team_Ids": teamIds,
        "backup_team_id": this.selectedBackupTeamId
      };
    this.migrationService.deleteTeam(request).subscribe(resp => {
      this.dialogRef.close(true);
    }, error => {
      this.dialogRef.close(false);
    });
  }

  assignTeam(team) {
    this.selectedBackupTeamId = team.id;
  }
  
  selectTeam(name, id, type) {
    this.selectedTeamName = name;
    this.selectedTeamId = id; 
    this.documentCols = [      
      'title',
      'create_date',
      'created_by',
      'file_size',
    ];
    let folderId = 0;
    let teamId = id;
    this.migrationService.getTeam(teamId, type, folderId, this.offset).subscribe((documents) => {      
      if (
        documents.Message ==
        'No records have been found matching the search criteria'
      ) {
        this.isDocumentExist = false;
        this.documentCount = 0;
      } else {
        this.isDocumentExist = true;
        this.documents = documents;
        this.documentCount = documents.count;
        if (this.documentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount = this.documents.results.length;
        //Get dynamic document columns
        var categoryKeys = documents['results'][0];
        var additionalCols: String[] = [];
        Object.keys(categoryKeys).forEach(function (key) {
          if (key.startsWith('display_')) {
            additionalCols.push(key);
          }
        });

        for (var i = 0; i < additionalCols.length; i++) {
          this.documentCols.push(additionalCols[i]);
        }
        this.docResultsList = new MatTableDataSource(this.documents.results);
        this.docResultsList.sort = this.sort;
        this.docResultsList.paginator = this.paginator;
      }
    }, error => {
      
    });
    
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  next() {
    this.offset = this.offset + 200;
    this.selectTeam(this.selectedTeamName, this.selectedTeamId, 'team');
  }

  previous() {
    this.offset = this.offset - 200;
    this.selectTeam(this.selectedTeamName, this.selectedTeamId, 'team');
  }

}
